import { Component, OnInit, OnDestroy } from "@angular/core";
import { PreviousUrlService } from "../services/previous-url.service";
import { SideNavBarVisibilityService } from "../services/side-nav-bar-visibility.service";
import { ThemeService } from "../theme/theme-service.service";
import { ZpDataService } from "../services/zp-data.service";
import { Subscription } from "rxjs";
import { UserInfoService } from "../services/user-info.service";

@Component({
  selector: "app-delegate-home-page",
  templateUrl: "./delegate-home-page.component.html",
  styleUrls: ["./delegate-home-page.component.scss"],
  standalone: false,
})
export class DelegateHomePageComponent implements OnInit {
  public isDefaultTheme: boolean;
  public activeTheme: any;
  public text: string;
  public isLifeFileTheme: boolean;
  public previousLink: string;
  public user: any;
  public subscription: Subscription;
  public statusMessages: boolean;
  public statusDelegateExplanations;
  public statusZenplanExplanations;
  retrievedMessagesLength: number;
  displayUnreadMessageBadge: boolean = false;
  totalUnreadMessages: number = 0;
  mySharedPlans: any[];
  public myUser: any;

  constructor(
    public sideNavBarVisibilityService: SideNavBarVisibilityService,
    private api: ZpDataService,
    public userService: UserInfoService,
    public themeService: ThemeService,
    private previousUrl: PreviousUrlService
  ) {}

  async ngOnInit() {
    this.subscription = this.userService
      .getMessage()
      .subscribe(async (user) => {
        this.user = JSON.parse(user);
        console.log(this.user);
      });
    this.previousLink = this.previousUrl.getPreviousUrl();
    console.log("previousLink: ", this.previousLink);
    if (this.previousLink === "/log-in" || this.previousLink === "/auth") {
      window.location.reload();
    }
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    switch (this.activeTheme.name) {
      case "lifeFile":
        this.text = "Life File";
        break;
      case "pemTheme":
        this.text = "PEM";
        break;
      case "palmersTheme":
        this.text = "Palmers Solicitors";
        break;
      case "weightmansTheme":
        this.text = "Weightmans";
        break;
    }
    this.statusMessages = true;
    if (this.user) {
      console.log("user: ", this.user);
      this.mySharedPlans = await this.api.getSharedPlans(this.user);
    } else {
      this.myUser = await this.api.getUser();
      this.mySharedPlans = await this.api.getSharedPlans(this.myUser);
    }
    console.log("mySharedPlans", this.mySharedPlans);
  }

  onGroupedMessagesLengthChange(length: number) {
    this.retrievedMessagesLength = length;
  }

  statusDelegateExplanation() {
    this.statusZenplanExplanations = false;
    this.statusDelegateExplanations = !this.statusDelegateExplanations;
  }

  statusZenplanExplanation() {
    this.statusDelegateExplanations = false;
    this.statusZenplanExplanations = !this.statusZenplanExplanations;
  }

  handleUnreadMessages(event: {
    hasUnreadMessages: boolean;
    totalUnreadMessages: number;
  }) {
    // Handle the event based on whether there are unread messages or not
    if (event.hasUnreadMessages) {
      // Update your parent component properties or perform any actions
      this.displayUnreadMessageBadge = true;
    } else {
      // Update your parent component properties or perform any actions
      this.displayUnreadMessageBadge = false;
    }

    // You can also access the total unread messages from event.totalUnreadMessages if needed
    console.log("Total Unread Messages:", event.totalUnreadMessages);
    this.totalUnreadMessages = event.totalUnreadMessages;
  }
}
